import { WizMathUtils } from '@wizeoo/akm-core-lib';
import { Domain, TranslatedEmb } from '@wizeoo/akm-message-lib';
import { Observable } from 'rxjs';
import { AttachmentService } from '../../command/core/attachment/attachment.service';
import { ViewData } from '../../model/view.data';
import { TranslatableLabelVO } from '../../vo/common/translation/translatable-label.vo';
import { BusinessUnitVO } from '../core/business-unit.vo';
import { IVo, field } from '@wizeoo/akm-compute-lib';
import { Model } from '../../model/model';

/**
 * Définition d'un domaine
 */
export class DomainVO implements IVo {
  
  protected _model: Model = null;
  public get model(): Model {
    return this._model as Model;
  }


  constructor(model: Model, public source: Domain = new Domain()) {
    this._model = model;
    if (!source.id) {
      source.uid = WizMathUtils.createUUID();
    }
  }

  public get id(): number {
    return this.source.id;
  }
  public set id(pValue: number) {
    this.source.id = pValue;
  }
  public get uid(): string {
    return this.source.uid;
  }
  public set uid(pValue: string) {
    this.source.uid = pValue;
  }
  public get domain(): string {
    return this.source.domain;
  }
  public set domain(pValue: string) {
    this.source.domain = pValue;
  }

  public get businessUnitCode(): string {
    return this.source.businessUnitCode;
  }
  public set businessUnitCode(pValue: string) {
    this.source.businessUnitCode = pValue;
  }

  /**
   * Le code du domaine (unique)
   */
  public get code(): string {
    // console.log('code', this.source.code);
    return this.source.code;
  }
  public set code(pValue: string) {
    this.source.code = pValue;
  }

  @field('TranslatedEmb')
  public set label(value: TranslatedEmb) {
    this.source.label = value;
  }
  public get label(): TranslatedEmb {
    return this.source.label;
  }

  public get ownerLogin(): string {
    return this.source.ownerLogin;
  }
  public set ownerLogin(value: string) {
    this.source.ownerLogin = value;
  }

  /** Libellé traductible */
  private _labelVO: TranslatableLabelVO;
  public get labelVO(): TranslatableLabelVO {
    if (!this._labelVO) {
      this._labelVO = this.model.localeEngine.newTranslatableVO(this, 'label');
    }
    return this._labelVO;
  }

  /**
   * La description du domaine
   */
   public get description(): string {
     if (!!this.getRootBU()) {
       return this.getRootBU().trsDescription;
     }
     return this.source.description;
   }


  // public set owner(pValue: UserVO) {
  //   this.source.owner = pValue.source;
  // }


  /**
   * Accès au libellé traduit
   */
  public get trsLabel(): string {
    return this.model.localeEngine.translate(this.label, this.code);
  }

  /** clé de filtre unifiée domaine / Bu */
  public get filterKey(): string {
    return this.trsLabel + '|' + this.code;
  }

  /**
   * l'objet existe en BDD (id)
   */
  public get exist(): boolean {
    return this.id > 0;
  }

  /** accesseur sur la BU racine */
  public getRootBU(): BusinessUnitVO {
    return this.model.businessUnitEngine.getByBusinessUnitCode(this.code, this.code);
  }

  /** accesseur sur l'icône de la BU racine */
  public get iconOrDie(): Observable<string> {
    const bu: BusinessUnitVO = this.getRootBU();
    if (!!bu) {
      return AttachmentService.getInstance().iconOrDie(bu.icon,  bu.domain, bu.businessUnitCode, ViewData.wildcardMainVision);
    } else {
      return AttachmentService.getInstance().iconOrDie(null,  null, null, null);
    }
  }
}
